import React, { useState } from 'react';
import './menuItemcard.css';
import 'bootstrap';
import P1 from '../../../assets/images/P1.png';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import inactiveBox from '../../../assets/images/InActive.png';
import no_img from '../../../assets/images/No-Image.jpg';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const MenuItemCard = ({ itemPic = P1, item, Currency, GetMenu }) => {
  debugger;
  const [show, setShow] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  let navigate = useNavigate();

  const handleClose = () => {
    if (deleting) return;
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const handleview = () => {
    navigate(`/admin/menu/${item?.itemName}/${item?.record_Id}`, { state: item });
  };

  const handleEdit = (item) => {
    navigate(`/admin/master/Update/${item?.itemName}`, { state: { item } });
  };

  const DeleteItem = async () => {
    if (deleting) return;

    try {
      setDeleting(true);

      const apiService = new ApiService();
      const body = {
        recordId: parseInt(item?.record_Id),
      };

      const res = await apiService.deleteBody('DELETE_ITEM_MASTER', body);

      if (res?.data?.statusCode === 204 || res?.data?.statusCode === 200) {
        toast.success(res?.data?.message || 'Item deleted successfully');
        setShow(false);

        // ✅ refresh list after delete
        if (typeof GetMenu === 'function') {
          await GetMenu();
        }
      } else {
        toast.warning(res?.data?.message || 'Failed to delete item');
      }
    } catch (error) {
      console.error('Delete item error:', error);
      toast.error('Something went wrong while deleting item');
    } finally {
      setDeleting(false);
    }
  };
  const getStock = (v) => {
    const toInt = (x) => (x === undefined || x === null || x === '' || isNaN(parseInt(x)) ? null : parseInt(x));
    return (
      toInt(v?.stock) ??
      toInt(v?.stockQty) ??
      toInt(v?.availableQty) ??
      toInt(v?.quantityOnHand) ??
      toInt(v?.itemMasterVarients?.[0]?.stock) ??
      toInt(v?.itemMasterVarients?.[0]?.availableQty) ??
      0
    );
  };
  const getStockStatus = (item) => {
    const actualStock = item.stockQuantity || item?.itemMasterVarients?.[0]?.stock || 0;
    const stock = parseInt(actualStock) || 0;

    if (stock === 0)
      return {
        status: 'Out of Stock',
        className: 'stock-badge-out',
        quantity: stock,
      };

    if (stock <= (item?.reorderLevel || item?.minStockLevel || 10))
      return {
        status: 'Low Stock',
        className: 'stock-badge-low',
        quantity: stock,
      };

    return {
      status: 'In Stock',
      className: 'stock-badge-in',
      quantity: stock,
    };
  };

  const stockInfo = getStockStatus(item);

  const truncatedName = item?.itemName?.length > 18 ? item?.itemName.substring(0, 18) + '...' : item?.itemName;
  const truncatedDescription = item?.description?.length > 45 ? item?.description.substring(0, 45) + '...' : item?.description;

  return (
    <>
      <div className="menu-item-card enhanced-card mt-5">
        <div className={`enhanced-status-badge ${item?.itemStatus ? 'active-badge' : 'inactive-badge'}`}>
          <span className="status-dot"></span>
          {item?.itemStatus ? 'Active' : 'Inactive'}
        </div>

        <div className="enhanced-image-section" onClick={() => handleview(item)}>
          <div className="image-wrapper">
            {imageLoading && (
              <div className="image-skeleton">
                <div className="skeleton-shimmer"></div>
              </div>
            )}
            <img
              src={item?.productImage || no_img}
              className={`item-pic enhanced-item-pic ${imageLoading ? 'loading' : ''}`}
              alt={item?.itemName}
              onLoad={() => setImageLoading(false)}
              onError={(e) => {
                e.target.src = no_img;
                setImageLoading(false);
              }}
            />
            <div className="enhanced-image-overlay">
              <span className="view-details-text">View Details</span>
              <div className="view-icon">👁️</div>
            </div>
          </div>
        </div>

        <div className="menu-item-details enhanced-content p-3">
          <div className="enhanced-header">
            <div className="item-name enhanced-title" title={item?.itemName}>
              {truncatedName || 'Untitled Item'}
            </div>
            {item?.brand && <div className="brand-badge">{item?.brand}</div>}
          </div>

          <div className="item-des enhanced-description mt-1" title={item?.description}>
            {truncatedDescription || 'No description available'}
          </div>

          <div className="enhanced-info-grid mt-2">
            <div className="info-row">
              <span className="info-label">Category:</span>
              <span className="info-value">{item?.category || 'N/A'}</span>
            </div>
            {item?.supplierName && (
              <div className="info-row">
                <span className="info-label">Supplier:</span>
                <span className="info-value">{item?.supplierName}</span>
              </div>
            )}
          </div>

          <div className="enhanced-price-section mt-2">
            <div className="price-main">
              <span className="price-label">Retail</span>
              <span className="item-price enhanced-price">
                {Currency.currency.name}{' '}
                {item?.retailPrice?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || '0.00'}
              </span>
            </div>
            {item?.wholesalePrice && item?.wholesalePrice !== item?.retailPrice && (
              <div className="price-secondary">
                <span className="price-label-small">Wholesale</span>
                <span className="price-value-small">
                  {Currency.currency.name}{' '}
                  {item?.wholesalePrice?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            )}
          </div>

          <div className="enhanced-stock-section mt-2">
            <div className={`stock-badge ${stockInfo.className}`}>
              <span className="stock-icon">📦</span>
              <span className="stock-text">{stockInfo.status}</span>
              <span className="stock-quantity">{getStock(item)}</span>
            </div>
          </div>

          <div className="actions enhanced-actions gap-3 mt-3 d-flex">
            <div className="w-50">
              <button className="edit-button enhanced-edit-btn" onClick={() => handleEdit(item)} disabled={deleting}>
                <svg className="btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Edit
              </button>
            </div>
            <div className="w-50">
              <button className="delete-button enhanced-delete-btn" onClick={handleShow} disabled={deleting}>
                <svg className="btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3,6 5,6 21,6" />
                  <path d="m19,6v14a2,2 0 0,1-2,2H7a2,2 0 0,1-2-2V6m3,0V4a2,2 0 0,1,2-2h4a2,2 0 0,1,2,2v2" />
                </svg>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered className="enhanced-delete-modal" backdrop={deleting ? 'static' : true} keyboard={!deleting}>
        <Modal.Header closeButton={!deleting} className="enhanced-modal-header">
          <Modal.Title className="enhanced-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
            Confirm Deletion
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="enhanced-modal-body">
          <div className="delete-confirmation">
            <p>Are you sure you want to delete this item?</p>
            <div className="item-preview-card">
              <img src={item?.productImage || no_img} alt={item?.itemName} className="preview-image" />
              <div className="preview-details">
                <strong>{item?.itemName}</strong>
                <span>{item?.brand}</span>
                <span className="preview-price">
                  {Currency.currency.name}{' '}
                  {item?.retailPrice?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) || '0.00'}
                </span>
              </div>
            </div>

            <div className="warning-message">
              <strong>⚠️ Warning:</strong> This action cannot be undone.
            </div>

            {deleting && (
              <div className="text-center mt-3">
                <div className="spinner-border spinner-border-sm text-danger" role="status">
                  <span className="visually-hidden">Deleting...</span>
                </div>
                <div className="mt-2 fw-semibold text-danger">Deleting item...</div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className="enhanced-modal-footer">
          <Button variant="outline-secondary" onClick={handleClose} className="cancel-btn" disabled={deleting}>
            Cancel
          </Button>

          <Button variant="danger" onClick={DeleteItem} className="confirm-delete-btn" disabled={deleting}>
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3,6 5,6 21,6" />
                  <path d="m19,6v14a2,2 0 0,1-2,2H7a2,2 0 0,1-2-2V6m3,0V4a2,2 0 0,1,2-2h4a2,2 0 0,1,2,2v2" />
                </svg>
                Delete Item
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        .enhanced-card {
          position: relative;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
          box-shadow: var(--shadow);
          background: var(--whiteBG);
        }

        .enhanced-card:hover {
          transform: translateY(-5px);
          box-shadow: 0px 8px 25px rgba(110, 81, 153, 0.15);
          border-color: var(--background);
        }

        .enhanced-status-badge {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 10;
          padding: 4px 10px;
          border-radius: 15px;
          font-size: 10px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 4px;
          backdrop-filter: blur(10px);
        }

        .active-badge {
          background: rgba(16, 185, 129, 0.9);
          color: white;
          border: 1px solid rgba(16, 185, 129, 0.3);
        }

        .inactive-badge {
          background: rgba(239, 68, 68, 0.9);
          color: white;
          border: 1px solid rgba(239, 68, 68, 0.3);
        }

        .status-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: currentColor;
        }

        .enhanced-image-section {
          position: relative;
          cursor: pointer;
          overflow: hidden;
        }

        .image-wrapper {
          position: relative;
          width: 100%;
          height: 240px;
        }

        .image-skeleton {
          position: absolute;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
        }

        .skeleton-shimmer {
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent 25%, rgba(255, 255, 255, 0.5) 50%, transparent 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        .enhanced-item-pic {
          transition: all 0.3s ease;
        }

        .enhanced-item-pic.loading {
          opacity: 0;
        }

        .enhanced-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(110, 81, 153, 0.85), rgba(110, 81, 153, 0.95));
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: all 0.3s ease;
          gap: 8px;
        }

        .enhanced-image-section:hover .enhanced-image-overlay {
          opacity: 1;
        }

        .enhanced-image-section:hover .enhanced-item-pic {
          transform: scale(1.05);
        }

        .view-details-text {
          color: white;
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .view-icon {
          font-size: 20px;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        .enhanced-content {
          position: relative;
        }

        .enhanced-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 8px;
          margin-bottom: 8px;
        }

        .enhanced-title {
          flex: 1;
          line-height: 1.3;
        }

        .brand-badge {
          background: linear-gradient(135deg, var(--background), rgba(110, 81, 153, 0.8));
          color: white;
          padding: 2px 8px;
          border-radius: 10px;
          font-size: 10px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          white-space: nowrap;
        }

        .enhanced-description {
          min-height: 36px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .enhanced-info-grid {
          background: rgba(110, 81, 153, 0.05);
          border-radius: 8px;
          padding: 8px;
          border: 1px solid rgba(110, 81, 153, 0.1);
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }

        .info-row:last-child {
          margin-bottom: 0;
        }

        .info-label {
          font-size: 11px;
          font-weight: 600;
          color: var(--background);
          text-transform: uppercase;
        }

        .info-value {
          font-size: 12px;
          font-weight: 500;
          color: #2c2f24;
          text-align: right;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .enhanced-price-section {
          background: linear-gradient(135deg, rgba(110, 81, 153, 0.05), rgba(110, 81, 153, 0.1));
          border-radius: 8px;
          padding: 10px;
          border: 1px solid rgba(110, 81, 153, 0.15);
        }

        .price-main {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }

        .price-label {
          font-size: 11px;
          font-weight: 600;
          color: var(--background);
          text-transform: uppercase;
        }

        .enhanced-price {
          font-size: 15px !important;
          font-weight: 700 !important;
          color: var(--background) !important;
        }

        .price-secondary {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .price-label-small {
          font-size: 10px;
          font-weight: 500;
          color: #666;
          text-transform: uppercase;
        }

        .price-value-small {
          font-size: 12px;
          font-weight: 600;
          color: #666;
        }

        .enhanced-stock-section {
          margin-bottom: 4px;
        }

        .stock-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 6px 10px;
          border-radius: 15px;
          font-size: 11px;
          font-weight: 600;
          border: 1px solid;
        }

        .stock-badge-in {
          background: rgba(16, 185, 129, 0.1);
          color: #059669;
          border-color: rgba(16, 185, 129, 0.3);
        }

        .stock-badge-low {
          background: rgba(245, 158, 11, 0.1);
          color: #d97706;
          border-color: rgba(245, 158, 11, 0.3);
        }

        .stock-badge-out {
          background: rgba(239, 68, 68, 0.1);
          color: #dc2626;
          border-color: rgba(239, 68, 68, 0.3);
        }

        .stock-icon {
          font-size: 12px;
        }

        .stock-quantity {
          opacity: 0.8;
        }

        .enhanced-actions .enhanced-edit-btn,
        .enhanced-actions .enhanced-delete-btn {
          position: relative;
          overflow: hidden;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          font-weight: 600;
        }

        .enhanced-actions .enhanced-edit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(110, 81, 153, 0.3);
        }

        .enhanced-actions .enhanced-delete-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(110, 81, 153, 0.2);
          background: var(--background) !important;
          color: white !important;
          border-color: var(--background) !important;
        }

        .enhanced-actions .enhanced-edit-btn:disabled,
        .enhanced-actions .enhanced-delete-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .btn-icon {
          transition: transform 0.2s ease;
        }

        .enhanced-edit-btn:hover .btn-icon,
        .enhanced-delete-btn:hover .btn-icon {
          transform: scale(1.1);
        }

        .enhanced-delete-modal .modal-content {
          border-radius: 15px;
          border: none;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .enhanced-modal-header {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          border-bottom: 1px solid #fecaca;
          padding: 20px 24px;
        }

        .enhanced-modal-title {
          color: #dc2626;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 0;
          font-size: 18px;
        }

        .enhanced-modal-body {
          padding: 24px;
        }

        .delete-confirmation p {
          font-size: 16px;
          color: #374151;
          margin-bottom: 20px;
          text-align: center;
        }

        .item-preview-card {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px;
          background: #f9fafb;
          border-radius: 12px;
          margin-bottom: 16px;
          border: 1px solid #e5e7eb;
        }

        .preview-image {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 8px;
          border: 2px solid white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .preview-details {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
        }

        .preview-details strong {
          color: #111827;
          font-size: 16px;
          font-weight: 600;
        }

        .preview-details span {
          color: #6b7280;
          font-size: 14px;
        }

        .preview-price {
          color: var(--background) !important;
          font-weight: 600 !important;
        }

        .warning-message {
          color: #dc2626;
          background: #fef2f2;
          padding: 12px;
          border-radius: 8px;
          border-left: 4px solid #dc2626;
          font-size: 14px;
          text-align: center;
        }

        .enhanced-modal-footer {
          padding: 16px 24px;
          background: #f9fafb;
          border-top: 1px solid #e5e7eb;
          display: flex;
          gap: 12px;
          justify-content: flex-end;
        }

        .cancel-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-weight: 600;
          border: 1px solid #d1d5db;
        }

        .confirm-delete-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          background: #dc2626 !important;
          border: 1px solid #dc2626 !important;
        }

        .confirm-delete-btn:hover {
          background: #b91c1c !important;
          border-color: #b91c1c !important;
        }

        @media only screen and (max-width: 600px) {
          .enhanced-card {
            margin: 10px;
          }

          .enhanced-info-grid {
            padding: 6px;
          }

          .enhanced-price-section {
            padding: 8px;
          }

          .enhanced-actions {
            flex-direction: column;
            gap: 8px !important;
          }

          .enhanced-actions .w-50 {
            width: 100% !important;
          }
        }

        @media only screen and (min-width: 768px) and (max-width: 992px) {
          .enhanced-card {
            margin: 10px;
          }
        }

        @media only screen and (min-width: 992px) and (max-width: 1024px) {
          .brand-badge {
            font-size: 9px;
            padding: 2px 6px;
          }

          .enhanced-price-section {
            padding: 8px;
          }
        }
      `}</style>
    </>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(MenuItemCard);
